import { Meta, Title } from '@angular/platform-browser';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { services } from '../../services';
import { DivisionsService } from '../../../../../../shared/modules/core/services/divisions.service';
import { TranslationService } from '../../../../../../shared/services/translations.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-wild-rift-solo-divisions',
  templateUrl: './wild-rift-divisions.component.html'
})
export class WildRiftDivisionsComponent {
  service = 'divisions';
  availableServices = services['wild-rift'].filter(service => service.service !== this.service);

  serviceParams = {
    game: 'wild-rift',
    service: 'divisions',
    type: 'solo',
    title: {
      en: 'Division Boosting',
    },
    subtitle: {
      en: 'Secure Your Desired Rank With Our Wild Rift Boosting Services',
      fr: 'Assure-toi le rang que tu veux avec nos services de boosting Wild Rift',
      de: 'Sichere dir deinen gewünschten Rang mit unseren Wild Rift Boosting Services',
      pt: 'Garante o rank desejado com os nossos serviços de boosting de Wild Rift',
      es: 'Asegura tu rango deseado con nuestros servicios de boosting de Wild Rift',
    },
    start: DivisionsService.getValueByRank('Silver I', 'wild-rift'),
    desired: DivisionsService.getValueByRank('Gold IV', 'wild-rift')
  }

  serviceFaqs = {
    en: [
      {
        question: "What Is A Division Elo Boost?",
        answer: "Wild Rift Elo Boosting can take the form of a Division Boost, which guarantees that the player will achieve the desired rank."
      },
      {
        question: "What If You Demote Or Lose The Promotion Series?",
        answer: "We promise to deliver the contracted service. Therefore, if something like that were to occur, we would go beyond it and finish the service as planned."
      },
      {
        question: "Can I Play With The Booster In Duo Queue Boosting?",
        answer: "Indeed, you can. To accomplish this, go to the order customization menu and select \"Duo\" before clicking \"Buy Boost Now\"."
      },
      {
        question: "Can I Choose My Preferred Champions/Roles And Summoner Spell Order?",
        answer: "Yes, you can. Click the \"Choose your Roles\" and \"Choose your Champions\" options in the order customization menu to make it happen."
      },
      {
        question: "Can I Play While The Order Is Active?",
        answer: "Yes, unless you want to queue in the same ranking mode as the bought service. Other than that, schedule it in the order chat with your booster."
      },
      {
        question: "Can I Request The Same Booster For A Future Purchase?",
        answer: "Yes! Click the heart icon inside the order dashboard to favorite a booster, then easily reassign them to your future orders."
      }
    ],
    fr: [
      {
        question: "Qu\'est-ce qu\'un Boost d\'Elo de Division?",
        answer: "Le Boosting d'Elo Wild Rift peut prendre la forme d'un Boost de Division, qui garantit que le joueur atteindra le rang désiré."
      },
      {
        question: "Que se passe-t-il si vous êtes rétrogradé ou si vous perdez la série de promotions?",
        answer: "Nous nous engageons à fournir le service contracté. Par conséquent, si une telle chose devait se produire, nous irions au-delà et terminerions le service comme prévu."
      },
      {
        question: "Puis-je jouer avec le Booster en Boosting Duo?",
        answer: "En effet, vous pouvez le faire. Pour ce faire, allez dans le menu de personnalisation de la commande et sélectionnez \"Duo\" avant de cliquer sur \"Acheter Boost maintenant\"."
      },
      {
        question: "Puis-je choisir mes champions/rôles préférés et l\'ordre des sorts d\'invocateur?",
        answer: "Oui, vous le pouvez. Cliquez sur les boutons 'Choisissez vos Rôles' et 'Choisissez votre Champion' dans le menu de personnalisation de la commande pour le faire."
      },
      {
        question: "Puis-je jouer pendant que la commande est active ?",
        answer: "Oui, sauf si vous voulez jouer dans le même mode classé que le service acheté. Dans le cas contraire, planifiez-le dans le chat de commande avec votre booster."
      },
      {
        question: "Puis-je demander le même booster pour un prochain achat?",
        answer: "Oui ! Cliquez sur l\'icône en forme de cœur dans le tableau de bord de commande pour ajouter un booster en favori, puis réassignez-le facilement à vos prochaines commandes."
      }
    ],
    de: [
      {
        question: "Was ist ein Division Elo Boost?",
        answer: "Wild Rift Elo Boosting kann in Form eines Division Boosting erfolgen, das dem Spieler das Erreichen des gewünschten Ranges garantiert."
      },
      {
        question: "Was passiert, wenn du degradierst, bevor der Dienst beendet ist?",
        answer: "Wir versprechen, die vertraglich vereinbarte Leistung zu erbringen. Sollte dies der Fall sein, so werden wir über unsere Verpflichtungen hinausgehen und den Dienst planmäßig zu Ende führen."
      },
      {
        question: "Kann ich mit dem Booster im Duo Queue Boosting spielen?",
        answer: "Ja, das kannst du. Gehe dazu in das Menü zur Bestellungsanpassung und wähle \"Duo\" aus, bevor du auf \"Boost Jetzt Kaufen\" klickst."
      },
      {
        question: "Kann ich meine bevorzugten Champions/Rollen und die Reihenfolge der Beschwörerzauber wählen?",
        answer: "Ja, das kannst du. Klicke im Menü zur Bestellungsanpassung auf die Optionen \"Wähle deine Rollen\" und \"Wähle deine Champions\", um dies zu ermöglichen. "
      },
      {
        question: "Kann ich spielen, während die Bestellung aktiv ist?",
        answer: "Ja, es sei denn, du möchtest im gleichen Ranking-Modus wie der gekaufte Dienst spielen. Ansonsten planst du das mit deinem Booster im Auftragschat."
      },
      {
        question: "Kann ich denselben Booster auch für einen späteren Kauf anfordern?",
        answer: "Ja! Klicke im Bestell-Dashboard auf das Herzsymbol, um einen Booster zu deinen Favoriten hinzuzufügen, und weise ihn dann ganz einfach zukünftigen Bestellungen zu."
      }
    ],
    pt: [
      {
        question: "O Que É Um Division Elo Boost?",
        answer: "O Division Elo Boost de Wild Rift garante que o booster irá alcançar o rank desejado."
      },
      {
        question: "O Que Acontece Se Eu For Despromovido No Decorrer Do Serviço?",
        answer: "Nós comprometemo-nos a concluir o serviço com sucesso. Portanto, se algo assim acontecer, iremos cumprir o serviço conforme planeado."
      },
      {
        question: "Posso Jogar com o Booster em Duo Queue?",
        answer: "Sim, podes. Para isso, vai ao menu de personalização do pedido e seleciona \"Duo\" antes de clicar em \"Comprar Boost agora\"."
      },
      {
        question: "Posso Escolher Os Meus Champions/Roles Favoritos E A Ordem Spells?",
        answer: "Sim, podes. Clica nas opções \"Escolhe os teus Roles\" e \"Escolhe os teus Champions\" no menu de personalização do serviço para o fazer."
      },
      {
        question: "Posso Jogar Enquanto O Serviço Está Activo?",
        answer: "Sim, a menos que queiras fazê-lo no mesmo modo de jogo do serviço comprado. Excepto isso, basta falares e agendares com o teu booster."
      },
      {
        question: "Posso Escolher O Mesmo Booster Para Uma Compra Futura?",
        answer: "Sim! Clica no ícone de coração dentro do painel do pedido para marcar um booster como favorito e depois escolhe-o facilmente nos teus próximos pedidos."
      }
    ],
    es: [
      {
        question: "¿Qué es una División Elo Boost?",
        answer: "El Elo boosting de Wild Rift puede adoptar la forma de un Division Boost, que garantiza que el jugador alcanzará el rango deseado."
      },
      {
        question: "¿Qué pasa si desciendes de categoría o pierdes la serie de ascensos?",
        answer: "Nos comprometemos a prestar el servicio contratado. Por lo tanto, si ocurriera algo así, iríamos más allá y terminaríamos el servicio según lo previsto."
      },
      {
        question: "¿Puedo jugar con los boosters en Duo Queue Boosting?",
        answer: "Efectivamente, puede hacerlo. Para ello, ve al menú de personalización del pedido y selecciona \"Duo\" antes de hacer clic en \"Comprar Boost Ahora\"."
      },
      {
        question: "¿Puedo elegir mis campeones/roles preferidos y el orden de los hechizos de invocador?",
        answer: "Sí, puedes hacerlo. Haz clic en las opciones \"Elige tus roles\" y \"Elige tus campeones\" en el menú de personalización del pedido para que esto suceda."
      },
      {
        question: "¿Puedo jugar mientras la orden está activa?",
        answer: "Sí, a menos que quieras hacer cola en el mismo modo de clasificación que el servicio comprado. Aparte de eso, prográmalo en el chat de órdenes con tu booster."
      },
      {
        question: "¿Puedo solicitar el mismo booster para una futura compra?",
        answer: "¡Sí! Haz clic en el ícono de corazón dentro del panel del pedido para añadir un booster a favoritos y así poder reasignarlo fácilmente en tus futuros pedidos."
      }
    ]
  }

  private page = {
    title: {
      en: "Wild Rift Boost - Premium Boosting for Wild Rift",
      fr: "Boost Wild Rift - Boosting Premium pour Wild Rift",
      de: "Wild Rift Boost - Premium Boosting für Wild Rift",
      pt: "Boost Wild Rift - Boosting Premium para Wild Rift",
      es: "Wild Rift Boost - Premium Boosting para Wild Rift",
    },
    metaDescription: {
      en: "We provide the Best and Safest Elo Boosting Services for Wild Rift. Our boosters are experienced players who can carry you up to Challenger",
      fr: "Nous fournissons les meilleurs services de boosting d\'Elo et les plus sûrs  pour Wild Rift. Nos boosters sont des joueurs expérimentés qui peuvent vous amener jusqu\'à Challenger",
      de: "Wir bieten dir den besten und sichersten Elo Boosting Service für Wild Rift an. Unsere Booster sind erfahrene Spieler, die in der Lage sind, dich bis zum Challenger zu bringen.",
      pt: "Oferecemos os melhores e mais seguros serviços de Boosting de Elo para Wild Rift. Nossos boosters são jogadores experientes que podem levá-lo até o Challenger.",
      es: "Proporcionamos los mejores y más seguros servicios de Elo boosting para Wild Rift. Nuestros boosters son jugadores experimentados que pueden llevarte hasta Challenger.",
    }
  }

  lang: string = 'en';

  constructor(meta: Meta, title: Title, private route: ActivatedRoute, private router: Router, private translationService: TranslationService, private cookie: CookieService) {
    this.route.params.subscribe(params => {
      if (Object.keys(params).length === 0) {
        const url = this.router.url.split('/');
        if (this.translationService.validLangs.includes(url[1])) {
          this.lang = url[1];
        } else {
          this.lang = this.cookie.get('gg-lang') || 'en';
        }
      } else {
        this.lang = params['lang'] || 'en';
      }
    });

    title.setTitle(this.page.title[this.lang] || this.page.title['en']);
    meta.updateTag(
      {
        name: 'description',
        content: this.page.metaDescription[this.lang] || this.page.metaDescription['en']
      },
    );
  }
}
